import {
    IconButton,
    ListItemIcon,
    ListItemText,
    Menu,
    MenuItem,
    Typography,
} from '@mui/material';

import { getETSUserCookiePayload } from '@b2b-ui/utilities/authentication';
import Logout from '@mui/icons-material/Logout';
import React from 'react';

import { useIntl } from 'react-intl';

import { StringAvatar } from '../components/StringAvatar';

import { LanguageModal } from './LanguageModal';
import { usePxToRem } from '@b2b-ui/hooks/theme';

type UserMenuProps = {
    enableLanguageSwitcher?: boolean;
    isUsingLocaleAsProp?: boolean;
};

export const UserMenu = ({
    enableLanguageSwitcher,
    isUsingLocaleAsProp,
}: UserMenuProps) => {
    const userInfo = getETSUserCookiePayload();
    const pxToRem = usePxToRem();
    const { formatMessage } = useIntl();
    const fullName = userInfo?.userName || '';
    const [anchorElement, setAnchorEl] = React.useState<null | HTMLElement>(
        null
    );

    const isOpen = Boolean(anchorElement);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const onClose = () => {
        setAnchorEl(null);
    };
    const logout = async () => {
        await fetch('/logout', { method: 'POST' });
        window.location.href = '/login';
    };

    return (
        <>
            <IconButton onClick={handleClick}>
                <StringAvatar
                    sx={{
                        width: pxToRem(28),
                        height: pxToRem(28),
                        fontSize: pxToRem(16),
                    }}
                    fullName={fullName}
                />
            </IconButton>
            <Menu
                sx={{ '& li': { minHeight: '48px!important' } }}
                anchorEl={anchorElement}
                open={isOpen}
                onClose={onClose}
                onClick={onClose}
            >
                <MenuItem
                    disableRipple
                    onClick={(e) => e.stopPropagation()}
                    divider
                >
                    <ListItemIcon>
                        <StringAvatar
                            fullName={fullName}
                            sx={{
                                width: pxToRem(28),
                                height: pxToRem(28),
                                fontSize: pxToRem(16),
                            }}
                        />
                    </ListItemIcon>
                    <ListItemText>
                        <Typography variant="h4">{fullName}</Typography>
                    </ListItemText>
                </MenuItem>
                {!isUsingLocaleAsProp && enableLanguageSwitcher && (
                    <LanguageModal onModalClose={onClose} />
                )}
                <MenuItem disableRipple onClick={logout}>
                    <ListItemIcon>
                        <Logout />
                    </ListItemIcon>
                    <ListItemText>
                        {formatMessage({ id: 'navbar.logout' })}
                    </ListItemText>
                </MenuItem>
            </Menu>
        </>
    );
};
